export { default } from "./RegistroCajas";
